/** Footer line under assistant bubbles (Fin-style). */
export function formatAssistantMeta(createdAt?: number): string {
  const base = 'Geofleet · AI Agent';
  if (createdAt == null) return `${base} · Just now`;
  const sec = Math.floor((Date.now() - createdAt) / 1000);
  if (sec < 45) return `${base} · Just now`;
  if (sec < 3600) return `${base} · ${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${base} · ${Math.floor(sec / 3600)}h ago`;
  return `${base} · Earlier`;
}

export function formatUserMeta(createdAt?: number): string {
  if (createdAt == null) return 'You · Just now';
  const sec = Math.floor((Date.now() - createdAt) / 1000);
  if (sec < 45) return 'You · Just now';
  if (sec < 3600) return `You · ${Math.floor(sec / 60)}m ago`;
  return 'You · Earlier';
}
